import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';

import { environment } from '../../../environments/environment';
import { StorageBrowser } from './storage.service';


@Injectable({
  providedIn: 'root',
})
export class  AppSocketService {
  socket?: Socket;
  private listeners: Map<string, (data: any) => void> = new Map();

  constructor(private storageBrowser: StorageBrowser) {   }

  connect() {
    const token = this.storageBrowser.get('token')
    if(!token) {
      console.warn('No token found, cannot connect to WebSocket');
      return;
    }
    this.socket = io(environment.socketUrl, {
      query: {token}
    });
    this.socket.on("connect", () => {
      this.socket?.emit("room", "USER_NOTIFICATION");
      console.log('Connected to server and joined room USER_NOTIFICATION');

      // Register all pending listeners after connection
      this.listeners.forEach((callback, event) => {
        this.socket?.on(event, callback);
        console.log(`Registered listener for event: ${event}`);
      });
    })
  }

  disconnect() {
    if (this.socket) {
        this.socket.disconnect();
    }
  }

  on<T = any>(event: string, callback: (data: T) => void) {
    // Store the callback for later registration
    this.listeners.set(event, callback as (data: any) => void);

    // If socket already exists, register immediately
    if (this.socket?.connected) {
      this.socket.on(event, callback);
    }
  }

  off<T = any>(event: string, callback?: (data: T) => void) {
    // Remove from stored listeners so it won't be re-registered on reconnect
    if (callback) {
      const existing = this.listeners.get(event);
      if (existing === (callback as (data: any) => void)) {
        this.listeners.delete(event);
      }
    } else {
      this.listeners.delete(event);
    }

    // If socket exists, remove listener(s) immediately
    if (this.socket) {
      try {
        if (callback) {
          this.socket.off(event, callback as any);
        } else {
          this.socket.off(event);
        }
      } catch (e) {
        // ignore removal errors
      }
    }
  }

  emit(event: string, data: any) {
    this.socket?.emit(event, data);
  }



}
